// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"e39d5dc4","913":"114f1fe5"}[chunkId] + ".chunk.js";
};